app.service('systemToolsService', function ($http) {


  // Routes | Email Creator |-----------------------------------------
  this.executeSQLStatement = function (obj) {
    return $http.post(`/emailCreator/executeSQLStatement`, obj)
      .then(function (response) {
        return response
      })
  }
  //------------------------------------------------------------------

})